import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Edit, Archive, ArchiveRestore, Phone, MapPin, User } from 'lucide-react';

export const WorkerTable = ({ workers, searchTerm, fmt, onEdit, onArchive, onRestore }) => (
  <Card className="hidden md:block bg-white border border-[#D1D1CD] rounded-lg shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-[#F4F4F0]">
            <TableHead className="font-semibold text-[#1C1C1E]">Name</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Phone</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Daily Wage</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] hidden md:table-cell">Address</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Status</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {workers.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center py-8 text-[#5C5C5C]">
                {searchTerm ? 'No workers found matching your search' : 'No workers added yet'}
              </TableCell>
            </TableRow>
          ) : (
            workers.map((worker) => (
              <TableRow key={worker.id} data-testid={`worker-row-${worker.id}`}>
                <TableCell>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-[#2E4632] flex items-center justify-center">
                      <User className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="font-medium text-[#1C1C1E]">{worker.name}</p>
                      {worker.id_proof && (
                        <p className="text-xs text-[#5C5C5C]">{worker.id_proof}</p>
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2 text-[#1C1C1E]">
                    <Phone className="w-4 h-4 text-[#5C5C5C]" />
                    {worker.phone}
                  </div>
                </TableCell>
                <TableCell>
                  <span className="font-semibold text-[#2E4632]">{fmt(worker.daily_wage)}</span>
                </TableCell>
                <TableCell className="hidden md:table-cell">
                  {worker.address ? (
                    <div className="flex items-center gap-2 text-[#5C5C5C] text-sm">
                      <MapPin className="w-4 h-4" />
                      <span className="truncate max-w-[200px]">{worker.address}</span>
                    </div>
                  ) : '-'}
                </TableCell>
                <TableCell>
                  <Badge className={(() => {
                    if (worker.archived) return 'bg-[#5C5C5C]/10 text-[#5C5C5C]';
                    return worker.is_active
                      ? 'bg-[#2E4632]/10 text-[#2E4632] hover:bg-[#2E4632]/20'
                      : 'bg-[#BC4749]/10 text-[#BC4749]';
                  })()}>
                    {(() => {
                      if (worker.archived) return 'Archived';
                      return worker.is_active ? 'Active' : 'Inactive';
                    })()}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">
                  <div className="flex items-center justify-end gap-2">
                    {worker.archived ? (
                      <Button
                        variant="ghost"
                        size="sm"
                        data-testid={`restore-worker-${worker.id}`}
                        onClick={() => onRestore(worker.id)}
                        className="h-10 text-[#2E4632] hover:bg-[#2E4632]/10"
                      >
                        <ArchiveRestore className="w-4 h-4 mr-1.5" /> Restore
                      </Button>
                    ) : (
                      <>
                        <Button
                          variant="ghost"
                          size="icon"
                          data-testid={`edit-worker-${worker.id}`}
                          onClick={() => onEdit(worker)}
                          className="h-10 w-10 text-[#5C5C5C] hover:text-[#2E4632] hover:bg-[#E8E8E3]"
                        >
                          <Edit className="w-4 h-4" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="icon"
                          data-testid={`archive-worker-${worker.id}`}
                          onClick={() => onArchive(worker.id)}
                          title="Archive worker (keeps their history)"
                          className="h-10 w-10 text-[#5C5C5C] hover:text-[#BC4749] hover:bg-[#BC4749]/10"
                        >
                          <Archive className="w-4 h-4" />
                        </Button>
                      </>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  </Card>
);
